<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex align-items-end gap-3">
    <div class="d-flex flex-column">
      <label
        class="form-label small text-muted mb-1"
        for="admin_organizations_filter_status"
      >
        Status
      </label>
      <kendo-dropdownlist
        id="admin_organizations_filter_status"
        [defaultItem]="{ text: 'All', value: null }"
        textField="text"
        valueField="value"
        [data]="statuses"
        [style]="{ width: '200px' }"
        (valueChange)="statusChange($event)"
      ></kendo-dropdownlist>
    </div>
    <div class="d-flex flex-column">
      <label
        class="form-label small text-muted mb-1"
        for="admin_organizations_filter_type"
      >
        Type
      </label>
      <kendo-dropdownlist
        id="admin_organizations_filter_type"
        [defaultItem]="{ display_text: 'All', id: null }"
        textField="display_text"
        valueField="id"
        [data]="accountTypeItems()"
        [style]="{ width: '240px' }"
        (valueChange)="accountTypeChange($event)"
      ></kendo-dropdownlist>
    </div>
  </div>
  <button
    kendoButton
    class="align-self-end"
    (click)="addOrg(bodyElement)"
    [svgIcon]="plusIcon"
    themeColor="primary"
  >
    Add Organization
  </button>
</div>

<app-datatable
  [data-href]="datatableUrl"
  [columns]="datatableColumns"
  [useOData]="true"
  [clickableRows]="true"
  (rowClick)="editOrg($event)"
></app-datatable>
